var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('cookie-law',{staticClass:"cookie sm:text-center sm:rounded sm:ml-6 sm:mb-3 sm:max-w-md",attrs:{"theme":"dark-lime","message":_vm.text,"button-text":_vm.buttonText}})
}
var staticRenderFns = []

export { render, staticRenderFns }